import { all, call, takeLatest, put, select } from 'redux-saga/effects'

import { jsonToFormdata } from '../../utils/mappers'
import { showAlertMessage } from '../alert/actions'
import {
  rejectPromiseAction,
  resolvePromiseAction
} from 'redux-saga-promise-actions'

import { getUsersRSPA } from '../users/services'
import * as actions from './actions'
import * as services from './services'

export function * fetchChats ({ payload }) {
  const {
    params,
    page,
    withoutFractalIdFilter,
    withoutRoomTypeFilter,
    archivedRooms,
    room_type
  } = payload
  const {
    room_menu: { current_destination },
    auth: { user: { data: { attributes: { fractal_id } } } }
  } = yield select()
  try {
    // esse parametro define se o usuário (admin) faz ou nao parte da sala
    let rooms_params = {
      ...(!withoutFractalIdFilter
        ? current_destination === 1
          ? { 'q[current_user_rooms]': true }
          : { 'q[room_participants_user_fractal_id_not_in]': fractal_id }
        : {}),
      'q[status_eq]': archivedRooms ? 1 : 0
    }
    // query para pegar pelo room_type ou pela flag de intervenção
    if (!withoutRoomTypeFilter) {
      if (room_type === 2) {
        rooms_params = {
          ...rooms_params,
          ...(current_destination === 1
            ? {
                'q[room_type_eq]': 0,
                'q[m]': 'and',
                'q[intervention_eq]': true
              }
            : {})
        }
      } else if (room_type || room_type === 0) {
        rooms_params = {
          ...rooms_params,
          'q[room_type_eq]': room_type,
          'q[intervention_not_eq]': true
        }
      }
    }
    const newPayload = {
      params: {
        ...params,
        ...rooms_params
      },
      page
    }
    const response = yield call(services.fetchRooms, newPayload)
    const responseDestination = withoutRoomTypeFilter ? null : room_type
    if (archivedRooms) {
      yield put(
        actions.getArchivedRoomsSuccessful({
          data: response.data,
          meta: { ...response.meta, current_page: page || 1 }
        })
      )
    } else {
      switch (responseDestination) {
        case 1:
          yield put(
            actions.getPrivateRoomsSuccessful({
              data: response.data,
              meta: { ...response.meta, current_page: page || 1 }
            })
          )
          break
        case 0:
          yield put(
            actions.getGroupRoomsSuccessful({
              data: response.data,
              meta: { ...response.meta, current_page: page || 1 }
            })
          )
          break
        case 2:
          yield put(
            actions.getMediationRoomsSuccessful({
              data: response.data,
              meta: { ...response.meta, current_page: page || 1 }
            })
          )
          break
        default:
          yield put(
            actions.getChatsSuccessful({
              data: response.data,
              meta: { ...response.meta, current_page: page || 1 }
            })
          )
          break
      }
    }
  } catch (error) {
    console.error(error)
    yield put(actions.getChatsFailure(error))
  }
}

export function * fetchChatById ({ payload }) {
  try {
    const response = yield call(services.fetchRoomById, payload)
    yield all(
      response.data.room_participants.map(function * (item) {
        const user = yield call(getUsersRSPA, {
          'q[fractal_id_eq]': item.user.fractal_id
        })
        return Object.assign(item, { user: user?.data?.[0] })
      })
    )
    yield put(actions.getChatByIdSuccessful({ data: response.data }))
  } catch (error) {
    console.error(error)
    yield put(
      showAlertMessage({
        message: 'Erro ao acessar a sala.',
        severity: 'error'
      })
    )
    yield put(actions.getChatByIdFailure(error))
  }
}

export function * createChats (action) {
  try {
    const { payload } = action
    const { cover_image } = payload
    let response
    if (cover_image instanceof Blob) {
      const fd = new FormData()
      fd.append('data[type]', 'rooms')
      fd.append(
        'data[attributes]room_type',
        +payload.room_type === 0 ? 'group' : 'private'
      )
      fd.append('data[attributes]cover_image', cover_image)
      payload?.room_participants_attributes?.length > 0 &&
        payload.room_participants_attributes.forEach(participant => {
          fd.append(
            'data[attributes][room_participants_attributes][][user_id]',
            participant.user_id
          )
          fd.append(
            'data[attributes][room_participants_attributes][][is_moderator]',
            participant.is_moderator
          )
          fd.append(
            'data[attributes][room_participants_attributes][][occupation_name]',
            participant.occupation_name
          )
          payload.read_only &&
            fd.append(
              'data[attributes][room_participants_attributes][][can_send_message]',
              participant?.can_send_message
            )
        })

      delete payload.room_participants_attributes
      delete payload.cover_image
      delete payload.room_type
      yield jsonToFormdata(fd, payload)
      response = yield call(services.createRoomWithFormData, fd)
    } else {
      response = yield call(services.createRoom, payload)
    }
    resolvePromiseAction(action, response)
  } catch (error) {
    console.error(error)
    rejectPromiseAction(action, error)
    yield put(
      showAlertMessage({
        message: 'Erro ao criar sala.',
        severity: 'error'
      })
    )
  }
}

export function * deleteMessage (action) {
  try {
    const { payload: { id } } = action
    const response = yield call(services.deleteMessage, id)
    resolvePromiseAction(action, response)
  } catch (error) {
    rejectPromiseAction(action, error)
    console.error(error)
  }
}

export function * editMessage (action) {
  try {
    const { payload } = action
    const data = { id: payload.id, data: payload.data }
    const response = yield call(services.editMessage, data)
    resolvePromiseAction(action, response)
  } catch (err) {
    console.error(err)
    rejectPromiseAction(action, err)
  }
}

export function * editRoom (action) {
  try {
    const { payload } = action
    const data = { id: payload.id, data: payload.data }
    const response = yield call(services.editRoom, data)
    resolvePromiseAction(action, response)
  } catch (error) {
    console.error(error)
    rejectPromiseAction(action, error)
  }
}

export function * createMessage (action) {
  try {
    const { payload } = action
    const { forwarding } = payload
    delete payload.forwarding
    let response
    const {
      room_menu: { current_room_type },
      chats: { mediationRooms, groupRooms, privateRooms }
    } = yield select()

    if (payload.files.length > 0) {
      const fd = new FormData()
      fd.append('data[type]', 'new_messages')
      fd.append('data[attributes][user_id]', payload.user_id)
      fd.append('data[attributes][room_id]', payload.room_id)
      fd.append('data[attributes][content]', payload.content)
      fd.append(
        'data[attributes][moderation_status]',
        payload.moderation_status
      )
      payload.files.forEach(file => {
        fd.append('data[attributes][message_files_attributes][][file]', file)
      })
      response = yield call(services.createMessageWithFile, fd)
    } else {
      delete payload.files
      response = yield call(
        !forwarding ? services.createMessage : services.forwardMessage,
        payload
      )
    }
    if (response && !forwarding) {
      const roomId = response?.data?.attributes?.room_id
      switch (current_room_type) {
        case 0: {
          const groupRoomsCopy = [...groupRooms.items]
          const previousIndex = groupRoomsCopy.findIndex(
            room => +room.id === +roomId
          )
          if (previousIndex > -1) {
            const [item] = groupRoomsCopy.splice(previousIndex, 1)
            groupRoomsCopy.unshift(item)
            yield put(
              actions.setGroupRoomsOrder({
                data: groupRoomsCopy
              })
            )
          }
          break
        }
        case 1: {
          const privateRoomsCopy = [...privateRooms.items]
          const previousIndex = privateRoomsCopy.findIndex(
            room => +room.id === +roomId
          )
          if (previousIndex > -1) {
            const [item] = privateRoomsCopy.splice(previousIndex, 1)
            privateRoomsCopy.unshift(item)
            yield put(
              actions.setPrivateRoomsOrder({
                data: privateRoomsCopy
              })
            )
          }
          break
        }
        case 2: {
          const mediationRoomsCopy = [...mediationRooms.items]
          const previousIndex = mediationRoomsCopy.findIndex(
            room => +room.id === +roomId
          )
          if (previousIndex > -1) {
            const [item] = mediationRoomsCopy.splice(previousIndex, 1)
            mediationRoomsCopy.unshift(item)
            yield put(
              actions.setMediationRoomsOrder({
                data: mediationRoomsCopy
              })
            )
          }
          break
        }
      }
    }
    resolvePromiseAction(action, response)
  } catch (err) {
    console.error(err)
    rejectPromiseAction(action, err)
  }
}

export function * getMessagesWithoutRoom (action) {
  function bindInclude (doc) {
    if (!doc || !Array.isArray(doc.data)) return []

    const included = Array.isArray(doc.included) ? doc.included : []

    // Índices de user
    const usersByFractalId = new Map() // chave: attributes.fractal_id -> user resource
    const usersById = new Map() // chave: id -> user resource

    // Índices de room e participants
    const roomsById = new Map() // chave: room.id -> room resource
    const participantsByRoomId = new Map() // chave: room_id -> [participant resources]

    // Indexa includes
    for (const inc of included) {
      if (!inc || !inc.type) continue

      if (inc.type === 'users') {
        usersById.set(String(inc.id), inc)
        const fid = inc?.attributes?.fractal_id
        if (fid !== undefined && fid !== null) {
          usersByFractalId.set(String(fid), inc)
        }
      }

      if (inc.type === 'rooms') {
        roomsById.set(String(inc.id), inc)
      }

      // room_participants (cobre typo 'room_articipants' também)
      if (inc.type === 'room_participants' || inc.type === 'room_articipants') {
        const rid = inc?.attributes?.room_id
        if (rid !== undefined && rid !== null) {
          const key = String(rid)
          if (!participantsByRoomId.has(key)) participantsByRoomId.set(key, [])
          participantsByRoomId.get(key).push(inc)
        }
      }
    }

    // Materializa participant com user pelo user_id -> usersById
    const materializeParticipant = p => {
      const out = { id: p.id, type: p.type, ...p.attributes }
      const pUserId = p?.attributes?.user_id
      if (pUserId !== undefined && pUserId !== null) {
        const u = usersById.get(String(pUserId)) // usa id real
        out.user = u ? { id: u.id, type: u.type, ...u.attributes } : null
      } else {
        out.user = null
      }
      return out
    }

    // Materializa room com participants
    const materializeRoom = roomIdRaw => {
      const roomRes = roomsById.get(String(roomIdRaw))
      if (!roomRes) return null
      const roomObj = {
        id: roomRes.id,
        type: roomRes.type,
        ...roomRes.attributes
      }
      const participants = participantsByRoomId.get(String(roomRes.id)) || []
      roomObj.participants = participants.map(materializeParticipant)
      return roomObj
    }

    // Materializa cada item de data
    const materialize = res => {
      if (!res) return res
      const attrs = { id: res.id, type: res.type, ...res.attributes }

      // user do item principal via fractal_id -> usersByFractalId
      const userIdRaw = res?.attributes?.user_id
      if (userIdRaw !== undefined && userIdRaw !== null) {
        const user = usersByFractalId.get(String(userIdRaw)) // fractal_id
        attrs.user = user
          ? { id: user.id, type: user.type, ...user.attributes }
          : null
      } else {
        attrs.user = null
      }

      // room completo
      const roomIdRaw = res?.attributes?.room_id
      attrs.room =
        roomIdRaw !== undefined && roomIdRaw !== null
          ? materializeRoom(roomIdRaw)
          : null

      return attrs
    }

    return doc.data.map(materialize)
  }
  try {
    const { payload } = action
    const response = yield call(services.getMessages, payload)
    resolvePromiseAction(action, bindInclude(response))
  } catch (err) {
    yield put(
      showAlertMessage({
        message: 'Erro ao acessar as mensagens.',
        severity: 'error'
      })
    )
    console.error(err)
    rejectPromiseAction(action, err)
  }
}

export function * getMessages (action) {
  try {
    const { payload } = action
    if (!payload?.roomId) {
      throw new Error('undefined room_id')
    }
    const response = yield call(services.getMessagesJsonApi, payload)
    resolvePromiseAction(action, response)
  } catch (err) {
    yield put(
      showAlertMessage({
        message: 'Erro ao acessar as mensagens.',
        severity: 'error'
      })
    )
    console.error(err)
    rejectPromiseAction(action, err)
  }
}

export function * getInterventionMessage (action) {
  try {
    const { payload } = action
    if (!payload?.roomId) {
      throw new Error('undefined room_id')
    }
    const response = yield call(services.getInterventionMessages, payload)
    resolvePromiseAction(action, response)
  } catch (err) {
    yield put(
      showAlertMessage({
        message: 'Erro ao acessar as mensagens intervidas.',
        severity: 'error'
      })
    )
    console.error(err)
    rejectPromiseAction(action, err)
  }
}

export function * fetchRoomsByIdRSPA (action) {
  try {
    const { payload: roomId } = action
    const response = yield call(services.fetchRoomById, roomId)
    resolvePromiseAction(action, response)
  } catch (err) {
    rejectPromiseAction(action, err)
  }
}

export function * exportMessages (action) {
  try {
    const { payload } = action
    const response = yield call(services.exportMessages, payload)
    resolvePromiseAction(action, response)
  } catch (error) {
    rejectPromiseAction(action, error)
  }
}

export function * fetchRoomsRspa (action) {
  try {
    const { payload } = action
    const response = yield call(services.fetchRooms, payload)
    resolvePromiseAction(action, response)
  } catch (err) {
    rejectPromiseAction(action, err)
  }
}

export function * deleteRoomRequest ({ payload }) {
  try {
    yield call(services.deleteRoom, payload)
    yield put(actions.deleteChatSuccessful(payload))
    yield put(
      showAlertMessage({
        message: 'Sala deletada com sucesso.',
        severity: 'success'
      })
    )
  } catch (error) {
    yield put(actions.deleteChatFailure(error))
    yield put(
      showAlertMessage({
        message: 'Falha ao deletar a sala.',
        severity: 'error'
      })
    )
  }
}

export function * watchFetchChats () {
  yield takeLatest(actions.getChats, fetchChats)
  yield takeLatest(actions.createChatRSPA.request, createChats)
  yield takeLatest(actions.getChatById, fetchChatById)
  yield takeLatest(actions.createMessageRSPA.request, createMessage)
  yield takeLatest(
    actions.getInterventionMessagesRSPA.request,
    getInterventionMessage
  )
  yield takeLatest(actions.getMessagesRSPA.request, getMessages)
  yield takeLatest(
    actions.getMessagesWithoutRoomRSPA.request,
    getMessagesWithoutRoom
  )
  yield takeLatest(actions.getRoomsRSPA.request, fetchRoomsRspa)
  yield takeLatest(actions.getRoomsByIdRSPA.request, fetchRoomsByIdRSPA)
  yield takeLatest(actions.deleteChat, deleteRoomRequest)
  yield takeLatest(actions.editMessageRSPA.request, editMessage)
  yield takeLatest(actions.deleteMessageRSPA.request, deleteMessage)
  yield takeLatest(actions.exportMessagesRSPA.request, exportMessages)
  yield takeLatest(actions.editRoomRSPA.request, editRoom)
}

export default function * chatsSagas () {
  yield all([watchFetchChats()])
}
